import React, { useContext } from 'react';
import * as _ from 'lodash';
import { useCurrentMatches } from '../../hooks/matches';
import { MATCH_STATUS } from '../../constants/match';
import VideoCard from './VideoCard';
import { DataContext } from '../../context/data-context';
import { LEAGUES } from '../../constants/leagues';

function HighlightsReelCarousel() {
  const { league } = useContext(DataContext);
  const [data] = useCurrentMatches();

  if (data.length > 0) {
    const finishedMatches = data.filter(
      (m) => m.status === MATCH_STATUS.FINISHED
    );
    const highlightsReels = finishedMatches
      .map((m) => m?.playlists?.highlights)
      .filter(Boolean);

    const highlightsReelsSorted = _.orderBy(highlightsReels, ['date'], 'desc');

    if (highlightsReels.length > 0) {
      return (
        <section className="row">
          <div className="col-12 d-flex px-sm-4 align-items-center mb-4 mt-5">
            <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
              HÖJDPUNKTER
            </h2>
          </div>
          <div className="col-12">
            <div className="video__container video__container--carousel">
              {highlightsReelsSorted.map((v) => (
                <VideoCard isFutsal={league === LEAGUES.FUTSAL} video={v} />
              ))}
            </div>
          </div>
        </section>
      );
    }

    return null;
  }

  return null;
}

export default HighlightsReelCarousel;
